import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import Loading from '../Loading/Loading';
import SliderProduct from '../Home/SliderProduct';
import { useState } from 'react';
import CampaignDetails from './CampaignDetails';

const CampaignProducts = () => {

    const { campaignId } = useParams()

    const { data, isLoading } = useQuery("campaignProductX", () => fetch(`${process.env.REACT_APP_SECRET_API}/campaign-product?filter[campaign_id]=${campaignId}`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()
    )
    )


    
    const [minPrice, setMinPrice] = useState(-Infinity);
    const [maxPrice, setMaxPrice] = useState(Infinity);

    const handlePriceChange = (e, isMin) => {
        const value = parseInt(e.target.value);
        if (isMin) {
            setMinPrice(isNaN(value) ? -Infinity : value);
        } else {
            setMaxPrice(isNaN(value) ? Infinity : value);
        }
    };



    if (isLoading) {
        return <Loading></Loading>
    }

    const latestProducts = data?.data

   

    const filteredProducts = latestProducts.filter(
        (product) => product?.product.price >= minPrice && product?.product?.price <= maxPrice
    );

    const products = filteredProducts.map(product => ({ ...product?.product, quantity: 1 }))
    console.log(products)


    return (
        <div>
            <CampaignDetails campaignId={campaignId}></CampaignDetails>
            {/* <h2 className="lg:text-2xl sm:text-sm text-center pt-10 font-medium text-gray-800 uppercase mb-6">{campaignName}</h2> */}
            <div className="container grid lg:grid-cols-4 sm:gird-cols-3 w-full gap-6 pt-10 pb-16 items-start">

                {/* sidebar  */}
                <div
                    className="col-span-3 lg:col-span-1 bg-white px-4 pt-4 pb-6 shadow rounded overflow-hidden lg:static left-4 top-16 z-10 w-full lg:block">
                    <div className="divide-gray-200 divide-y space-y-5">
                        <div className="pt-4">
                            <h3 className="text-xl text-gray-800 mb-3 uppercase font-medium">Price</h3>
                            <div className="mt-4 flex items-center">
                                <input type="text"
                                    className="w-full border-2 focus:ring-0 focus:border-primary px-3 py-1 text-gray-600 text-sm shadow-sm rounded"
                                    placeholder="min" onChange={(e) => handlePriceChange(e, true)} />
                                <span className="mx-3 text-gray-500">-</span>
                                <input type="text"
                                    className="w-full border-2 focus:ring-0 focus:border-primary px-3 py-1 text-gray-600 text-sm shadow-sm rounded"
                                    placeholder="max" onChange={(e) => handlePriceChange(e, false)} />
                            </div>
                        </div>
                        {/* price filter end  */}
                    </div>
                </div>
                {/* sidebar end  */}

                {/* products  */}
                <div className="col-span-3">
                    <div className="col-span-3">
                        {products?.length > 0 ? (
                            <div className="grid lg:grid-cols-2 xl:grid-cols-3 grid-cols-2 gap-6">
                                {products?.map((product) => (
                                    <SliderProduct product={product} key={product.id}></SliderProduct>
                                ))}
                            </div>
                        ) : (
                            <p className='text-xl text-center text-red-500 font-semibold'>No products available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignProducts;